export const AUTHENTICATION = 'AUTHENTICATION';

export const authentication = (isAuthen: boolean) => ({
  type: AUTHENTICATION,
  isAuthen
});